import { Controller } from "@hotwired/stimulus";

const TOP_GRADE = "stopped_day";

export default class extends Controller {
  static targets = ["grade", "care", "fallback"];

  connect() {
    this.fallbackTargets.forEach((element) => {
      element.hidden = true;
    });
    this.gradeChanged();
  }

  gradeChanged() {
    if (!this.hasCareTarget) return;
    const grade = this.gradeTargets.find((input) => input.checked)?.value;
    this.careTarget.hidden = grade !== TOP_GRADE;
  }
}
